/**
 * Ir_library
 * @constructor
 */
class Ir_library {
  constructor() {}
  /**
   * コモン
   */
  init() {
    
    //News　アコーディオン
    $('.js-acc-btn').on('click', function () {
      $(this).toggleClass('is-active');
      $(this).next().stop().slideToggle();
    })
    
  }
}

export default Ir_library;